import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
export function useIsDown(breakpoint) {
  var screenOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var theme = useTheme();
  var inputQuery = screenOnly ? "@media screen and (max-width:".concat(theme.breakpoints.values[breakpoint] - 0.05, "px)") : theme.breakpoints.down(breakpoint);
  return useMediaQuery(inputQuery);
}
export function useIsUp(breakpoint) {
  var screenOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var theme = useTheme();
  var inputQuery = screenOnly ? "@media screen and (min-width:".concat(theme.breakpoints.values[breakpoint] - 0.05, "px)") : theme.breakpoints.up(breakpoint);
  return useMediaQuery(inputQuery);
}
export function useIsResolution(resolution) {
  var max = resolution.max,
    min = resolution.min;
  var inputQuery = '@media screen and ';
  if (min) inputQuery = "".concat(inputQuery, "(min-width: ").concat(min, "px)");
  if (min && max) inputQuery = "".concat(inputQuery, " and ");
  if (max) inputQuery = "".concat(inputQuery, "(max-width: ").concat(max, "px)");
  return useMediaQuery(inputQuery);
}